var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFolderIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 41,
    viewBox: "0 0 43 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7058 13.2247H18.5281C17.8558 13.2246 17.2134 12.9463 16.7535 12.4559L14.153 9.68332C13.6923 9.1924 13.049 8.91424 12.3757 8.91504H3.90493C2.5611 8.91504 1.47168 10.0045 1.47168 11.3483V38.4855C1.47168 39.8308 2.56226 40.9214 3.9076 40.9214H38.7011C40.0464 40.9214 41.137 39.8308 41.137 38.4855V15.658C41.137 14.3149 40.0488 13.2258 38.7058 13.2247Z",
    fill: "#EDBB4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2959 0.0771484H36.8674V26.5546H7.2959V0.0771484Z",
    fill: "#ECECEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74414 2.53516H34.4152V28.1127H5.74414V2.53516Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98633 5.78809H31.1746V6.95226H8.98633V5.78809Z",
    fill: "#DBD8DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98633 9.48633H31.1746V10.6505H8.98633V9.48633Z",
    fill: "#DBD8DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98633 13.1846H31.1746V14.3487H8.98633V13.1846Z",
    fill: "#DBD8DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.568 17H18.526C17.8553 17 17.2144 17.2768 16.7545 17.7651L14.1529 20.5271C13.6931 21.0154 13.0522 21.2922 12.3814 21.2922H2.43334C1.08951 21.2923 8.89834e-05 22.3816 0 23.7255C0 23.7994 0.00338137 23.8733 0.0100551 23.9468L1.26864 38.5779C1.38307 39.8323 2.43494 40.7925 3.69459 40.7925H38.914C40.1737 40.7925 41.2257 39.832 41.3399 38.5774L42.9897 19.6551C43.1122 18.3169 42.1266 17.1327 40.7884 17.0101C40.7151 17.0035 40.6416 17.0001 40.568 17Z",
    fill: "#FFD15C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFolderIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/folderIcon.5369b07a.svg";
export { ForwardRef as ReactComponent };